import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BreadcrumbModule } from './breadcrumb/breadcrumb.module';
import { ContentModule } from './content/content.module';
import { LayoutModule } from './layout/layout.module';
import { NavigationModule } from './navigation/navigation.module';

@NgModule({
	declarations: [],
	exports: [LayoutModule, NavigationModule, BreadcrumbModule, ContentModule],
	imports: [CommonModule, LayoutModule, NavigationModule, BreadcrumbModule, ContentModule]
})
export class DashboardModule {}
